export { default } from './parseSchemaObject'
